import React from "react"
import Header from "../components/header"

const HeaderFrame = ({ data, pageContext: { currentBrand, brandNames } }) => {
  return (
    <Header currentBrand={currentBrand} forceExternal noBanner isHome={false} />
  )
}

export default HeaderFrame
